import type { Href, Router } from 'expo-router'

export function parseBackendSessionIdParam(
  value: string | string[] | undefined,
): number | null {
  const raw = Array.isArray(value) ? value[0] : value
  if (raw == null || raw === '') {
    return null
  }

  const parsed = Number(raw)
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null
  }

  return parsed
}

/**
 * Push the standalone voice-assessment intro route. The backend
 * session is still minted lazily from inside the flow when the user
 * explicitly taps "Start assessment".
 */
export function pushNewVoiceAssessmentRoute(
  router: Pick<Router, 'push'>,
): void {
  router.push('/voice-assessment')
}

export function buildVoiceAssessmentRoute(
  backendSessionId: number,
  options: { source?: 'onboarding' } = {},
): Href {
  return {
    pathname: '/(protected)/(account)/voice-assessment/[sessionId]',
    params:
      options.source != null
        ? { sessionId: String(backendSessionId), source: options.source }
        : { sessionId: String(backendSessionId) },
  }
}
